import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {JbSpringBatchStatusDto} from "../../model/dto/entity/jb-spring-batch-status.dto";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class JbSpringBatchService {

    private readonly baseUrl: string;

    constructor(protected http: HttpClient) {
        this.baseUrl = MvsCrudService.baseUrl + '/jb/springBatch';
    }

    /**
     * Get jobs status matching the given pattern.
     *
     * @param pattern SQL LIKE pattern for job names (e.g., "import%", "cm_%")
     * @param onlyActive if true, only return running (STARTED) jobs
     * @returns Observable with status DTO containing job executions and counts
     */
    getJobsStatus(pattern: string = '%', onlyActive: boolean = false): Observable<JbSpringBatchStatusDto> {
        const params = new HttpParams()
            .set('pattern', pattern)
            .set('onlyActive', onlyActive.toString())
            .set('_t', Date.now().toString()); // Cache-busting parameter

        return this.http.get<JbSpringBatchStatusDto>(`${this.baseUrl}/status`, {params});
    }

    /**
     * Stop a running job execution.
     *
     * @param executionId the job execution ID to stop
     * @returns Observable with boolean indicating if stop signal was sent successfully
     */
    stopJob(executionId: number): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/stop/${executionId}`, {});
    }

    /**
     * Mark an orphaned job execution as failed.
     * Use this for jobs that appear running but are actually stuck
     * (e.g., system was restarted while job was running).
     *
     * @param executionId the job execution ID to mark as failed
     * @returns Observable with boolean indicating if the job was marked as failed
     */
    markOrphanedJobAsFailed(executionId: number): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/markFailed/${executionId}`, {});
    }
}
